<template>
  <div class="modal fade contact_form_modal" :id="this.id" @click.self="closeModal" v-if="showModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content"  >
        <div class="modal-header" :class="header_class">
          <h4 class="modal-title" >
            <slot name="title"></slot>
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
          <div class="modal-btns">
            <button class="btn btn--100 button-red" @click.prevent="closeModal">
              <slot name="button"></slot>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:{
      id:String,
      header_class: {
        type:String,
        default:""
      }
    },
    data() {
      return {
        showModal: false,
      }
    },
    methods:{
      closeModal() {
        let vm = this;
        $(function () {
          $('#' + vm.id).modal('hide')
        })
        this.$emit('close');
      },
      openModal() {
        console.log(this.id)
        this.$emit('open');
        this.showModal = true;
        let vm = this;
        this.$nextTick(function () {
          $(function () {
            $('#' + vm.id).modal('show')
          })

        })
      }
    }
  }
</script>